var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-info" },
    [
      _c("div", { staticClass: "template-title" }, [_vm._v("参赛人员资料")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "player-content" },
        [
          _c("PlayerInfo"),
          _vm._v(" "),
          _c("time-out", {
            attrs: { count: _vm.teachingTime, title: "距离上传结束" },
            on: { timeIsOvered: _vm.timeIsOvered }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "template-title margin-bt" }, [
        _vm._v("上传教学反思材料")
      ]),
      _vm._v(" "),
      _vm.hasSubmitted
        ? _c("div", { staticClass: "submitted-file" }, [
            _c("img", {
              staticClass: "submitted-file-icon",
              attrs: { src: _vm.activeDocIcon, alt: "教学反思文件" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "submitted-file-name" }, [
              _vm._v(_vm._s(_vm.asyncPosters.name))
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "submitted-file-preview",
                on: { click: _vm.previewFile }
              },
              [_vm._v("在线预览")]
            )
          ])
        : _c(
            "div",
            [
              _c("upload-view", {
                attrs: {
                  type: "doc,pdf",
                  fileDesc: "",
                  tag: "",
                  deleteable: true,
                  img: "",
                  icon: _vm.defaultDocIcon,
                  activeIcon: _vm.activeDocIcon,
                  index: 0,
                  path: _vm.asyncPosters.url,
                  name: _vm.asyncPosters.name,
                  activityId: _vm.activityId,
                  playerId: _vm.playerId,
                  couldPreview: !!_vm.asyncPosters.url,
                  changeObj: { show: "", text: "" }
                },
                on: {
                  uploadSucc: _vm.uploadPosterSuccess,
                  deleteFile: _vm.cancleImg,
                  preview: _vm.previewFile
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "tips" }, [_vm._v("文件大小: 小于等于10M")]),
      _vm._v(" "),
      _vm.hasSubmitted
        ? _c("div", { staticClass: "submitted-tip" }, [
            _vm._v("教学反思已提交，祝您取得理想成绩。")
          ])
        : _c(
            "el-button",
            {
              staticClass: "btn-submit",
              attrs: { type: "primary" },
              on: { click: _vm.confirmSubmit }
            },
            [_vm._v("提交")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11fb3414", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11fb3414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingRelection.vue
// module id = null
// module chunks = 